import React from 'react';
import { useState, useEffect } from 'react';
import { init, useConnectWallet } from '@web3-onboard/react';
import injectedModule from '@web3-onboard/injected-wallets';
import { ethers } from 'ethers';

// Initialize Web3-Onboard
const injected = injectedModule();

init({
  wallets: [injected],
  chains: [{
    id: '0x1',
    token: 'ETH',
    label: 'Ethereum Mainnet',
    rpcUrl: 'https://mainnet.infura.io/v3/YOUR_INFURA_ID'
  }]
});

// CountdownTimer Component
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const endDate = new Date("January 30, 2025 23:59:59").getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000)
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="countdown">
      <CountdownItem value={timeLeft.days} label="Days" />
      <CountdownItem value={timeLeft.hours} label="Hours" />
      <CountdownItem value={timeLeft.minutes} label="Minutes" />
      <CountdownItem value={timeLeft.seconds} label="Seconds" />
    </div>
  );
};

const CountdownItem = ({ value, label }) => (
  <div className="countdown-item">
    <span>{value}</span>
    <span className="label">{label}</span>
  </div>
);

// CyberButton Component
const CyberButton = ({ children, onClick, disabled = false }) => {
    return (
        <button 
            className="cyber-button" 
            onClick={onClick}
            disabled={disabled}
        >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            {children}
        </button>
    );
};

// Aggiungi questa costante per l'indirizzo del contratto
const PRESALE_ADDRESS = "0xc2a4399db83B62E5Ca7E384B04f85D4d96d0799d" // Indirizzo da configurare successivamente
const BNB_AMOUNT = "0.05"

const PresaleCommand = () => {
    const [{ wallet, connecting }, connect, disconnect] = useConnectWallet();
    const [isTransacting, setIsTransacting] = useState(false);

    const handleBuyAider = async () => {
        if (!wallet) return;
        
        try {
            setIsTransacting(true);
            const provider = new ethers.providers.Web3Provider(wallet.provider);
            const signer = provider.getSigner();
            
            const transaction = {
                to: PRESALE_ADDRESS,
                value: ethers.utils.parseEther(BNB_AMOUNT)
            };

            const tx = await signer.sendTransaction(transaction);
            await tx.wait();
            
            console.log('Transaction completed:', tx.hash);
        } catch (error) {
            console.error('Error during transaction:', error);
        } finally {
            setIsTransacting(false);
        }
    };

    return (
        <div className="overview-container">
            {/* ASCII Art Title */}
            <pre className="ascii-art">{`
██████╗ ██████╗ ███████╗███████╗ █████╗ ██╗     ███████╗
██╔══██╗██╔══██╗██╔════╝██╔════╝██╔══██╗██║     ██╔════╝
██████╔╝██████╔╝█████╗  ███████╗███████║██║     █████╗  
██╔═══╝ ██╔══██╗██╔══╝  ╚════██║██╔══██║██║     ██╔══╝  
██║     ██║  ██║███████╗███████║██║  ██║███████╗███████╗
╚═╝     ╚═╝  ╚═╝╚══════╝╚══════╝╚═╝  ╚═╝╚══════╝╚══════╝`}</pre>

            {/* Main Content Box */}
            <div className="content-box">
                <div className="box-header">
                    🚀🚀 AIDER TOKEN PRESALE: BE AN EARLY ADOPTER! 🚀🚀
                </div>

                <div className="box-content">
                    <p>
                        The AIDER token presale is now live! Don't miss your chance to be part 
                        of the AI revolution. Join us in democratizing artificial intelligence 
                        and secure your position in the future of technology.
                    </p>

                    <section className="feature-section">
                        <h3>🎉🎉 Exciting news!</h3>
                        <p>
                            The AIDER token presale is now live! Don't miss your chance to be 
                            part of the AI revolution.
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>💎💎 Presale Details:</h3>
                        <p>
                            • Total Presale Tokens: 100,000,000 AIDER (10% of total supply)<br/>
                            • Presale Price: 50000 AIDER / 0.05 BNB<br/>
                            • Minimum Purchase: 50,000 AIDER (0.05 BNB)<br/>
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>🚀🚀 Why Participate?</h3>
                        <p>
                            • Get in early before the public sale<br/>
                            • Potential for significant returns as the project grows<br/>
                            • Be part of the AI revolution from day one<br/>
                            • Exclusive access to platform features
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>💡💡 How to Participate:</h3>
                        <p>
                            1. Connect your wallet (we support MetaMask, Trust Wallet, and more)<br/>
                            2. Click on Buy AIDER (0.05 BNB)<br/>
                            3. Complete the transaction using BNB
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>⏰⏰ Limited Time Offer</h3>
                        <p>The presale ends January 30, 2025. Don't miss out on this opportunity!</p>
                    </section>

                    <div className="prediction">
                        <h3>✨✨ AIDER - Fueling the AI Revolution! ✨✨</h3>
                    </div>
                                       
                    {/* Add CountdownTimer here */}
                    <CountdownTimer />

                    {/* Sostituire il vecchio container del bottone con questo nuovo */}
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        gap: '20px',
                        marginTop: '50px',
                        marginBottom: '20px',
                        flexWrap: 'wrap'
                    }}>
                        <CyberButton 
                            onClick={() => (wallet ? disconnect(wallet) : connect())}
                            disabled={connecting}
                        >
                            {connecting ? 'Connecting...' : wallet ? 'Disconnect Wallet' : 'Connect Wallet'}
                        </CyberButton>

                        <CyberButton 
                            onClick={handleBuyAider}
                            disabled={!wallet || isTransacting}
                            style={{
                                backgroundColor: wallet ? 'rgba(0, 255, 0, 0.2)' : 'rgba(128, 128, 128, 0.2)',
                                borderColor: wallet ? '#00ff00' : '#808080',
                                cursor: wallet ? 'pointer' : 'not-allowed'
                            }}
                        >
                            {isTransacting ? 'Processing...' : 'Buy AIDER (0.05 BNB)'}
                        </CyberButton>
                    </div>

                    {/* Aggiungere il display delle informazioni del wallet */}
                    {wallet && (
                        <div style={{
                            textAlign: 'center',
                            marginBottom: '50px',
                            padding: '10px',
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            borderRadius: '8px'
                        }}>
                            <p style={{ margin: '0' }}>
                                Connected: {wallet.accounts[0].address.slice(0, 6)}...{wallet.accounts[0].address.slice(-4)}
                            </p>
                        </div>
                    )}

                    <div className="disclaimer">
                        Disclaimer: Cryptocurrency investments carry inherent risks. Please do your own research 
                        and invest responsibly. Past performance does not guarantee future results.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PresaleCommand;
